document.addEventListener("DOMContentLoaded", function () {


  //==================================== for back to top script
  const backToTopBtn = document.getElementById("backToTopBtn");
  window.addEventListener("scroll", function () {
    if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
      backToTopBtn.style.display = "flex";
    } else {
      backToTopBtn.style.display = "none";
    }
  });

  backToTopBtn.addEventListener("click", function () {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });
  //==================================== 


  if (window.location.pathname === '/' || window.location.pathname === '/index.html') {
    document.querySelector('store-header.header').classList.add('home-page');
  }
  if (window.location.pathname !== '/' && window.location.pathname !== '/index.html') {
      document.querySelector('store-header.header').classList.add('not-home-page');
  }

  const sliders = document.querySelectorAll('.scroll-area.is-scrollable');

  sliders.forEach((slider) => {
    let isDown = false;
    let isDragging = false;
    let startX;
    let scrollLeft;
  
    // Prevent dragstart on images and links
    slider.querySelectorAll('a, img').forEach((el) => {
      el.addEventListener('dragstart', (e) => e.preventDefault());
    });
  
    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      isDragging = false;
      slider.classList.add('grabbing');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });
  
    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('grabbing');
    });
  
    slider.addEventListener('mouseup', (e) => {
      slider.classList.remove('grabbing');
  
      // If user dragged and released on a link, prevent accidental click
      if (isDragging && e.target.closest('a')) {
        e.preventDefault();
      }
  
      isDown = false;
      isDragging = false;
    });
  
    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
  
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1.5;
  
      if (Math.abs(walk) > 5) {
        isDragging = true;
      }
  
      slider.scrollLeft = scrollLeft - walk;
    });
  });
  
  // const sliders = document.querySelectorAll('.scroll-area.is-scrollable');

  // sliders.forEach((slider) => {
  //   let isDown = false;
  //   let startX;
  //   let scrollLeft;

  //   slider.addEventListener('mousedown', (e) => {
  //     isDown = true;
  //     slider.classList.add('grabbing');
  //     startX = e.pageX - slider.offsetLeft;
  //     scrollLeft = slider.scrollLeft;
  //   });

  //   slider.addEventListener('mouseleave', () => {
  //     isDown = false;
  //     slider.classList.remove('grabbing');
  //   });

  //   slider.addEventListener('mouseup', () => {
  //     isDown = false;
  //     slider.classList.remove('grabbing');
  //   });

  //   slider.addEventListener('mousemove', (e) => {
  //     if (!isDown) return;
  //     e.preventDefault();
  //     const x = e.pageX - slider.offsetLeft;
  //     const walk = (x - startX) * 1.5;
  //     slider.scrollLeft = scrollLeft - walk;
  //   });
  // });
});


// document.addEventListener("DOMContentLoaded", function () {
//   // Wait a tiny bit so Shopify animations finish (important!)
//   setTimeout(() => {
//     // Try multiple selectors because headings are wrapped by <split-lines>
//     const heading =
//       document.querySelector(".custom_slider_1 .heading") ||
//       document.querySelector(".custom_slider_1 [data-sequence='heading']") ||
//       document.querySelector(".custom_slider_1 .h1");

//     if (!heading) {
//       console.warn("Countdown heading not found.");
//       return;
//     }

//     // ---- APPEND COUNTDOWN ----
//     const countdown = document.createElement("div");
//     countdown.className = "bf-countdown";
//     // countdown.innerHTML = `
//     //   <div class="bf-countdown__inner">
//     //     <div class="bf-countdown__item"><span id="bf-days">00</span><small>Days</small></div>
//     //     <div class="bf-countdown__item"><span id="bf-hours">00</span><small>Hours</small></div>
//     //     <div class="bf-countdown__item"><span id="bf-mins">00</span><small>Mins</small></div>
//     //     <div class="bf-countdown__item"><span id="bf-secs">00</span><small>Secs</small></div>
//     //   </div>
//     //   <div class="bf-below-countdown__inner">
//     //     <p>Mark your calendar — deals go live on November 28, 2025!</p>
//     //   </div>
//     // `;

//     // <div class="bf-discount-badge">UP TO 60% OFF</div>
//     countdown.innerHTML = `
      
//       <div class="bf-timer-wrapper" bis_skin_checked="1">
//         <div class="bf-timer-label" bis_skin_checked="1">Sale Starts In</div>
//         <div class="bf-timer" id="timer" bis_skin_checked="1">
//             <div class="bf-timer-block" bis_skin_checked="1">
//                 <span class="bf-timer-number" id="bf-days"">13</span>
//                 <span class="bf-timer-text">Days</span>
//             </div>
//             <div class="bf-timer-block" bis_skin_checked="1">
//                 <span class="bf-timer-number" id="bf-hours">03</span>
//                 <span class="bf-timer-text">Hours</span>
//             </div>
//             <div class="bf-timer-block" bis_skin_checked="1">
//                 <span class="bf-timer-number" id="bf-mins">10</span>
//                 <span class="bf-timer-text">Minutes</span>
//             </div>
//             <div class="bf-timer-block" bis_skin_checked="1">
//                 <span class="bf-timer-number" id="bf-secs">39</span>
//                 <span class="bf-timer-text">Seconds</span>
//             </div>
//         </div>
//     </div>
//     <p class="bf-description">
//         Don't miss out on the biggest shopping event of the year!<br>
//         November 28, 2025 - Incredible deals await you.
//     </p>
//     `;


    

//     heading.insertAdjacentElement("afterend", countdown);

//     // ---- COUNTDOWN LOGIC ----
//     // Set the correct Black Friday date (2025)
//     // const targetDate = new Date("November 28, 2025 00:00:00").getTime();
//     const targetDate = new Date("2025-11-28T00:00:00Z").getTime();
//     function updateCountdown() {
//       const now = new Date().getTime();
//       const diff = targetDate - now;

//       if (diff <= 0) return;

//       const days = Math.floor(diff / (1000 * 60 * 60 * 24));
//       const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
//       const mins = Math.floor((diff / (1000 * 60)) % 60);
//       const secs = Math.floor((diff / 1000) % 60);

//       document.getElementById("bf-days").textContent = String(days).padStart(2, "0");
//       document.getElementById("bf-hours").textContent = String(hours).padStart(2, "0");
//       document.getElementById("bf-mins").textContent = String(mins).padStart(2, "0");
//       document.getElementById("bf-secs").textContent = String(secs).padStart(2, "0");
//     }

//     // Run instantly + every second
//     updateCountdown();
//     setInterval(updateCountdown, 1000);
//   }, 150); // slight delay fixes Shopify split-lines timing issues
// });


// document.addEventListener("DOMContentLoaded", () => {
//   const interval = setInterval(() => {
//     const shadowHost = document.querySelector("shopify-forms-embed");
//     if (shadowHost && shadowHost.shadowRoot) {
//       const grid = shadowHost.shadowRoot.querySelector("._grid_1q1d2_148");
//       if (grid) {
//         grid.style.display = "grid";
//         grid.style.gridTemplateColumns = "1fr 1fr"; // 2 equal columns
//         grid.style.maxWidth = "800px";
//         clearInterval(interval);
//       }
//     }
//   }, 100);
// });


// function styleEarlyAccessGrid() {
//   const shadowHost = document.querySelector("shopify-forms-embed");
//   if (!shadowHost || !shadowHost.shadowRoot) return;

//   const title = shadowHost.shadowRoot.querySelector('h2');
//   if (!title || title.textContent.trim() !== "Black Friday Early Access") return;

//   const grid = shadowHost.shadowRoot.querySelector("._grid_1q1d2_148");
//   if (grid) {
//     grid.style.display = "grid";
//     grid.style.gridTemplateColumns = "1fr 1fr";
//     grid.style.maxWidth = "800px";
//     console.log("Grid styled successfully!");

//     // Stop observing shadow DOM to prevent repeated styling
//     if (shadowObserver) shadowObserver.disconnect();
//   }
// }

// // Create a shadow observer variable
// let shadowObserver;

// // Observe for when Shopify form renders
// const observer = new MutationObserver(() => {
//   const shadowHost = document.querySelector("shopify-forms-embed");
//   if (shadowHost && shadowHost.shadowRoot) {
//     // Set up shadow observer once
//     if (!shadowObserver) {
//       shadowObserver = new MutationObserver(styleEarlyAccessGrid);
//       shadowObserver.observe(shadowHost.shadowRoot, { childList: true, subtree: true });
//     }
//     // Try styling immediately in case content is already present
//     styleEarlyAccessGrid();
//   }
// });

// // Observe body for dynamically injected forms
// observer.observe(document.body, { childList: true, subtree: true });

// // Also run on DOMContentLoaded for already-present forms
// document.addEventListener("DOMContentLoaded", () => {
//   styleEarlyAccessGrid();
// });







document.addEventListener("DOMContentLoaded", () => {
  const interval = setInterval(() => {
    const shadowHost = document.querySelector("shopify-forms-embed");
    if (shadowHost && shadowHost.shadowRoot) {

      const title = shadowHost.shadowRoot.querySelector('h2');
      if (!title) return;

      // Only apply changes to THIS specific popup
      if (title.textContent.trim() === "Black Friday Early Access") {
        const grid = shadowHost.shadowRoot.querySelector("._grid_1q1d2_148");
        if (grid) {
          grid.style.display = "grid";
          grid.style.gridTemplateColumns = "1fr 1fr";
          grid.style.maxWidth = "800px";
          clearInterval(interval);
        }
      }
    }
  }, 100);
});
document.addEventListener("DOMContentLoaded", function() {
  var path = window.location.pathname;

  var custom_contact_us_uk_button = document.getElementById("custom-contact-us-uk-button");
  var custom_contact_us_italy_button = document.getElementById("custom-contact-us-italy-button");


  if (path.startsWith("/it-it")) {
    var section = document.getElementById("shopify-section-template--26235324531068__featured_collection_JtjLc8");

    if (section) {
      section.remove();
      console.log("section removed on Italy pages ✅");
    }
    var section2 = document.getElementById("shopify-section-template--26235324531068__featured_collection_bpP3xz");
    if (section2) {
      section2.remove();
      console.log("section2 removed on Italy pages ✅");
    }

    var section3 = document.getElementById("shopify-section-template--26235324531068__custom_liquid_rpRrN6");
    if (section3) {
      section3.remove();
      console.log("section3 removed on Italy pages ✅");
    }
    
    if (custom_contact_us_italy_button) custom_contact_us_italy_button.style.display = "block";
    if (custom_contact_us_uk_button) custom_contact_us_uk_button.style.display = "none";

  }else{
    if (custom_contact_us_italy_button) custom_contact_us_italy_button.style.display = "none";
    if (custom_contact_us_uk_button) custom_contact_us_uk_button.style.display = "block";
  }






});

// document.addEventListener("DOMContentLoaded", function () {
//   if (window.location.pathname !== "/pages/contact-us") return;

//   const proseContainer = document.querySelector(".prose");
//   if (!proseContainer) return;

//   const contactInfoHTML = `
//     <div class="beargrip-contact-info">
      
//       <div class="beargrip-contact-section">
//         <div class="beargrip-contact-title">Business Inquiries</div>
//         <ul class="beargrip-contact-list">
//           <li>Email: <a href="mailto:info@beargrip.co.uk">info@beargrip.co.uk</a></li>
//           <li>Landline: <a href="tel:020 3916 5997">020 3916 5997</a></li>
//         </ul>
//       </div>

//       <div class="beargrip-contact-section">
//         <div class="beargrip-contact-title">Customer Service</div>
//         <ul class="beargrip-contact-list">
//           <li>Email: <a href="mailto:customerservice@beargrip.co.uk">customerservice@beargrip.co.uk</a></li>
//           <li>WhatsApp: <a href="https://wa.me/447376718773" target="_blank">Chat on WhatsApp</a></li>
//           <li>Shopify Chat: 24/7</li>
//         </ul>
//       </div>

//     </div>
//   `;
  
//   console.log('contact us');

//   proseContainer.insertAdjacentHTML("beforeend", contactInfoHTML);
// });
